export default (editor, config = {}) => {
  const commands = editor.Commands;
}
